/*/
 * Swiper v8
/*/
	import Swiper, { EffectFade, Lazy, Navigation, Scrollbar } from 'swiper';

	const siteSwiperTimeline = new Swiper('[site-timeline]', {
		modules: [EffectFade],
		loop: false,
		speed: 500,
		threshold: 5,
		autoHeight: true,
		grabCursor: false,
		simulateTouch: false,
		allowTouchMove: false,
		longSwipes: false,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		on: {
			slideChangeTransitionStart() {
				siteSwiperTimelineNav.slideTo(this.realIndex, 500)
			}
		}
	})

	const siteSwiperTimelineNav = new Swiper('[site-timeline-nav]', {
		modules: [Scrollbar],
		loop: false,
		speed: 500,
		threshold: 5,
		slidesPerView: 'auto',
		autoHeight: false,
		centerInsufficientSlides: false,
		centeredSlides: true,
		grabCursor: true,
		scrollbar: {
			el: '.swiper-scrollbar',
			draggable: true,
			dragSize: 150,
			lockClass: 'd-none',
			snapOnRelease: true
		},
		on: {
			slideChangeTransitionStart() {
				this.$el[0].querySelector('.is--active').classList.remove('is--active')
				this.$el[0].querySelectorAll('.swiper-slide')[this.activeIndex].querySelector('button').classList.add('is--active')
				siteSwiperTimeline.slideTo(this.realIndex, 500)
			},
			scrollbarDragEnd() {
				this.$el[0].querySelector('.is--active').classList.remove('is--active')
				this.$el[0].querySelectorAll('.swiper-slide')[this.activeIndex].querySelector('button').classList.add('is--active')
				siteSwiperTimeline.slideTo(this.realIndex, 500)
			}
		}
	})

	const siteSwiperTimelineSwitcher = document.querySelectorAll('[site-timeline-set]')

	if (siteSwiperTimelineSwitcher) {
		siteSwiperTimelineSwitcher.forEach(e => {
			e.addEventListener('click', _ => {
				const index = e.dataset.slide
				siteSwiperTimelineNav.slideTo(index, 500)
			})
		})
	}

	siteSwiperTimeline.slideTo(2, 500);
	siteSwiperTimelineNav.slideTo(2, 500);

	// galleries
	const count1 = document.querySelectorAll('[swiper-company-gallery-1] .swiper-slide').length > 1 ? true : false
	const count2 = document.querySelectorAll('[swiper-company-gallery-2] .swiper-slide').length > 1 ? true : false

	const siteSwiperGallery1 = new Swiper('[swiper-company-gallery-1]', {
		modules: [Navigation, Lazy],
		loop: count1,
		speed: 1000,
		threshold: 5,
		autoHeight: false,
		grabCursor: true,
		navigation: {
			prevEl: '.swiper-prev-1',
			nextEl: '.swiper-next-1',
		},
		lazy: {
			loadPrevNext: true,
			loadPrevNextAmount: 1,
		},
	})

	const siteSwiperGallery2 = new Swiper('[swiper-company-gallery-2]', {
		modules: [Navigation, Lazy],
		loop: count1,
		speed: 1000,
		threshold: 5,
		autoHeight: false,
		grabCursor: true,
		navigation: {
			prevEl: '.swiper-prev-2',
			nextEl: '.swiper-next-2',
		},
		lazy: {
			loadPrevNext: true,
			loadPrevNextAmount: 1,
		},
	})
